<div class="authentication-bg min-vh-100">
  <div class="bg-overlay bg-white"></div>
  <!-- Language Switcher -->
  <div class="language-switcher-container">
    <app-language-switcher></app-language-switcher>
  </div>
  <div class="container">
    <div class="col-row">
      <div class="col-md-6">
        <div class="w-full">
          <div class="mb-4 mb-md-5 responsive-auth-header">
            <a routerLink="/" class="d-block auth-logo">
              <div class="d-flex gap-3">
                <img src="assets/images/HC-logo.svg" alt="HotelCard Logo" class="logo" />
                <img src="assets/images/hotelcard-text.svg" alt="HotelCard" class="hotelcard-text" />
                <span class="mt-3 responsive-divider">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2"
                    height="30"
                    viewBox="0 0 2 30"
                    fill="none"
                  >
                    <path d="M1.24854 2.18557e-08L1.24853 30" stroke="white" />
                  </svg>
                </span>
                <span class="text-white extranet">Extranet</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="row justify-content-center my-auto">
        <div class="col-lg-6">
          <div class="responsive-center-card responsive-auth-page-card">
            <div class="card auth-cover-card overflow-hidden">
              <div class="row g-0">
                <div class="col-lg-12">
                  <div
                    class="login-form-card bg-white h-100 d-flex align-items-center justify-content-center auth-card"
                  >
                    <div class="w-full">
                      <!-- Header -->
                      <div class="text-center mb-4">
                        <div class="verify-2fa-icon mb-3">
                          <lucide-icon name="shield"></lucide-icon>
                        </div>
                        <h5 class="welcome-text">{{ 'AUTH.VERIFY_2FA.TITLE' | translate }}</h5>
                        <p class="verify-2fa-description">
                          @if (!isRecoveryMode) {
                            {{ 'AUTH.VERIFY_2FA.DESCRIPTION' | translate }}
                          } @else {
                            {{ 'AUTH.VERIFY_2FA.RECOVERY_DESCRIPTION' | translate }}
                          }
                        </p>
                      </div>

                      <!-- TOTP Code Input -->
                      @if (!isRecoveryMode) {
                        <div class="digit-inputs-container mb-4">
                          @for (digit of verificationDigits; track $index) {
                            <input
                              type="text"
                              class="digit-input"
                              [id]="'verify-digit-' + $index"
                              [value]="digit"
                              maxlength="1"
                              inputmode="numeric"
                              pattern="[0-9]"
                              autocomplete="one-time-code"
                              (input)="onDigitInput($index, $event)"
                              (keydown)="onDigitKeyDown($index, $event)"
                              (paste)="onPaste($event)"
                            />
                          }
                        </div>
                      }

                      <!-- Recovery Code Input -->
                      @if (isRecoveryMode) {
                        <div class="mb-4">
                          <label class="form-label">{{ 'AUTH.VERIFY_2FA.RECOVERY_CODE_LABEL' | translate }}</label>
                          <!-- TODO: account pages use dark theme — needs design review before migrating to hc-input -->
                          <input
                            type="text"
                            class="form-control form-input-dark"
                            [(ngModel)]="recoveryCode"
                            [placeholder]="'AUTH.VERIFY_2FA.RECOVERY_CODE_PLACEHOLDER' | translate"
                            (keyup.enter)="onSubmit()"
                          />
                        </div>
                      }

                      <!-- Error Message -->
                      @if (error) {
                        <div class="alert alert-danger mb-3">
                          {{ error }}
                        </div>
                      }

                      <!-- Remember Device Checkbox -->
                      <div class="mb-3 d-flex align-items-center">
                        <hc-checkbox
                          [label]="'AUTH.VERIFY_2FA.REMEMBER_DEVICE' | translate"
                          [(ngModel)]="rememberMe">
                        </hc-checkbox>
                        <lucide-icon
                          name="info"
                          class="ms-1 text-muted cursor-pointer"
                          [ngbTooltip]="'AUTH.VERIFY_2FA.REMEMBER_DEVICE_HINT' | translate"
                          placement="top">
                        </lucide-icon>
                      </div>

                      <!-- Submit Button -->
                      <div class="mb-3">
                        <hc-button
                          variant="primary"
                          [fullWidth]="true"
                          size="md"
                          [disabled]="isVerifying || (!isRecoveryMode && !isCodeComplete()) || (isRecoveryMode && !recoveryCode.trim())"
                          (clicked)="onSubmit()">
                          @if (isVerifying) {
                            <span class="spinner-border spinner-border-sm me-1"></span>
                          }
                          {{ 'AUTH.VERIFY_2FA.SUBMIT' | translate }}
                        </hc-button>
                      </div>

                      <!-- Toggle Recovery Mode -->
                      <div class="text-center mb-3">
                        <hc-button
                          variant="link"
                          class="toggle-recovery-link"
                          (clicked)="toggleRecoveryMode()">
                          @if (!isRecoveryMode) {
                            {{ 'AUTH.VERIFY_2FA.USE_RECOVERY_CODE' | translate }}
                          } @else {
                            {{ 'AUTH.VERIFY_2FA.USE_AUTHENTICATOR' | translate }}
                          }
                        </hc-button>
                      </div>

                      <!-- Back to Login -->
                      <div class="text-center">
                        <a
                          class="text-decoration-underline forgot-password cursor-pointer"
                          (click)="backToLogin()"
                          (keyup.enter)="backToLogin()"
                          tabindex="0"
                        >{{ 'AUTH.VERIFY_2FA.BACK_TO_LOGIN' | translate }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
